import Left from '@material-ui/icons/ChevronLeftRounded';
import React from 'react';

import Button from '../Button';

interface IProps {
  label: string;
  backTo?: () => void;
}

const CardHeader = ({ backTo, label}: IProps): JSX.Element => {

  return (
    <div className="card-header">
      { backTo && (
        <Button
          color="primary"
          className="back-button"
          onClick={backTo}
        >
          <Left color="primary" fontSize="large" />
        </Button>
      )}
      <h4 className="header-title">
        {label}
      </h4>
  </div>
  );
};

export { CardHeader };
